<app-layout>
  <div class="header container"><h1>Biliothèque virtuelle</h1></div>
</app-layout>
